import type { ExclusionReasons } from 'pages/StudyList/StudyListItem/ExclusionReason/ExclusionReason';

export const errorMessages: Record<string, string> = {
  emptyLabel: 'Label cannot be empty',
  duplicatedLabel: 'Label already used. Please enter a unique label',
  maxLength: 'Label cannot exceed 255 characters',
  emptyList: 'List can`t be empty. Please add at least one exclusion reason.',
  generic: 'Error saving changes. Please try again or refresh the page.',
};

const validateReason = (value: string, fields: ExclusionReasons) => {
  const trimmedWord = value.trim();
  if (!trimmedWord) return errorMessages.emptyLabel;

  const exists = fields.some((field) => field.reason === trimmedWord);
  if (exists) {
    return errorMessages.duplicatedLabel;
  }

  const isTooLong = trimmedWord.length > 255;
  if (isTooLong) {
    return errorMessages.maxLength;
  }

  return true;
};

export default validateReason;
